var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_1019)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.435 -0.000976562H15.5925C6.27 -0.000976562 0 6.54402 0 16.279V38.7465C0 48.454 6.27 54.999 15.5925 54.999H39.435C48.7575 54.999 55 48.454 55 38.7465V16.279C55 6.54402 48.7575 -0.000976562 39.435 -0.000976562Z",
    fill: "#F25D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3269 37.9887C36.9667 37.9887 36.6037 37.8952 36.2709 37.6999L25.4744 31.2594C24.8529 30.8854 24.4707 30.2117 24.4707 29.4857V15.6064C24.4707 14.4679 25.3947 13.5439 26.5332 13.5439C27.6717 13.5439 28.5957 14.4679 28.5957 15.6064V28.3142L38.3857 34.1524C39.3619 34.7382 39.6837 36.0032 39.1007 36.9822C38.7129 37.6284 38.0282 37.9887 37.3269 37.9887Z",
    fill: "#F25D27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.b7948b2f3b1decce2e6c6f4914a28c0d.svg";
export { ForwardRef as ReactComponent };